import { MessageTypesE } from 'declarations/enums/messages';
import type { LastMessageI } from 'declarations/interfaces/tickets';

const parseMessagePrefix = (value: string): string => value.replace(/^.*?:\s*/, '');

/** Screenshot with no caption: show message `text` after the `Sender:` prefix. */
export const getScreenshotTextWithoutCaption = (freeText: string): string =>
  parseMessagePrefix(freeText.trim()).trim();

export const getLastMessageDisplayText = (lastMessage: LastMessageI | undefined): string => {
  if (!lastMessage) {
    return '';
  }
  if (lastMessage.typeId === MessageTypesE.ScreenshotUpload) {
    const rawLine = (lastMessage.text ?? '').split('{')[0].trim();
    const attachmentName = lastMessage.attachmentName?.trim() ?? '';
    const attachmentText = lastMessage.attachmentText?.trim() ?? '';

    if (attachmentText) {
      return attachmentName ? `${attachmentText} ${attachmentName}`.trim() : attachmentText;
    }

    const bodyOnly = getScreenshotTextWithoutCaption(rawLine);
    if (bodyOnly) {
      return bodyOnly;
    }
    return attachmentName;
  }

  const messageToDisplay = lastMessage.attachmentText
    ? lastMessage.attachmentText
    : lastMessage.text;
  return parseMessagePrefix(messageToDisplay ?? '');
};
